<template>
  <div class="row-col">
    <a
      data-dismiss="modal"
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize"> {{ couponExists(coupon.id) ? 'Update' : 'Create' }} Voucher</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">

          <fieldset
            class="padding">
            <form>

              <!-- Name -->
              <div
                :class="{'invalid':errors.has('name')}"
                class="md-form-group">
                <input
                  v-validate="'required'"
                  :disabled="loading"
                  v-model="coupon.name"
                  type="text"
                  name="name"
                  class="md-input"
                  placeholder="Required">
                <label>Voucher Code</label>
                <span
                  v-show="errors.has('name')"
                  class="form-error-msg">{{ errors.first('name') }}</span>
              </div>
              <!-- Availability Date -->
              <div class="row">
                <div class="col-sm-6">
                  <div class="md-form-group">
                    <label class="typo__label multiselect-label">Redemption Start Date</label>
                    <calendar
                      v-model="coupon.available_from"
                      :config="{'format': 'YYYY-MM-DD'}"
                      :disabled="loading"/>
                    <small>The coupon will only be available for redemption on the start date onwards</small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="md-form-group">
                    <label class="typo__label multiselect-label">Redemption End Date</label>
                    <calendar
                      v-model="coupon.available_to"
                      :config="{'format': 'YYYY-MM-DD'}"
                      :disabled="loading"/>
                    <small>The coupon will only be available for redemption before the end date</small>
                  </div>
                </div>
              </div>

              <div
                :class="{'invalid':errors.has('limit_quantity')}"
                class="md-form-group">
                <input
                  v-validate="minimumLimitQuantity"
                  :disabled="loading"
                  :name="'limit_quantity'"
                  v-model="coupon.limit_quantity"
                  type="number"
                  data-vv-as="Limit Quantity"
                  class="md-input quantity"
                >
                <label>Quantity Limit Voucher</label>
                <span
                  v-if="errors.has('limit_quantity')"
                  class="form-error-msg">{{ errors.first('limit_quantity') }}</span>
              </div>

              <!-- Price -->
              <div
                :class="{'invalid':errors.has('price')}"
                class="md-form-group">
                <input
                  v-validate="'required|decimal:2|min_value:0'"
                  :disabled="loading"
                  :name="'Price'"
                  v-model="coupon.price"
                  type="number"
                  class="md-input"
                >
                <label>Amount</label>
                <span
                  v-show="errors.has('price')"
                  class="form-error-msg">{{ errors.first('price') }}</span>
              </div>

              <!-- Mode select -->
              <div class="form-group m-t-sm">
                <label class="typo__label multiselect-label">Mode</label>
                <multiselect
                  v-if="couponExists(coupon.id)"
                  v-model="modeSelect"
                  :max-height="170"
                  :options="modeList"
                  label="name"
                  track-by="id"/>
                <multiselect
                  v-else
                  v-model="coupon.mode"
                  :max-height="170"
                  :options="modeList"
                  label="name"
                  track-by="id"/>
              </div>

              <div
                :class="{'invalid':errors.has('is_recurring')}"
                class="md-form-group">
                <div style="display: flex">
                  <label class="md-switch">
                    <input
                      v-model="coupon.is_recurring"
                      type="checkbox"
                      name="is_recurring"
                    >
                    <i class="primary"/>
                    Recurring day
                  </label><br>
                  <i
                    style="margin-top: 5px; margin-left: 5px;"
                    data-toggle="tooltip"
                    title="Daily auto top up based on quantity limit until end of redemption date."
                    class="fa fa-info-circle"
                    aria-hidden="true"/>
                    <!--                <small>Auto top up based on limit and available based redemption date.</small>-->

                </div>
              </div>
              
              <div class="md-form-group p-b-sm">
                <label class="md-switch">
                  <input
                    v-model="coupon.for_product"
                    type="checkbox"
                    name="for_product"
                    @change="forProduct"
                  >
                  <i class="primary"/>
                  Applicable Products
                </label>
                <label class="md-switch">
                  <input
                    v-model="coupon.for_tag"
                    type="checkbox"
                    name="for_tag"
                    @change="forTag"
                  >
                  <i class="primary"/>
                  Applicable Tags
                </label>
              </div>

            

              <!-- Products select -->
              <div
                v-if="product"
                class="form-group m-t-sm">
                <label class="typo__label multiselect-label">Products</label>
                <multiselect
                  id="ajaxProducts"
                  v-model="coupon.products"
                  :options="productList"
                  :multiple="true"
                  :loading="products_loading"
                  :close-on-select="false"
                  :limit="20"
                  :max-height="170"
                  :hide-selected="true"
                  label="name"
                  track-by="id"
                  placeholder="Type to search"
                  @search-change="loadProducts"/>
              </div>
              <!-- Tags select -->
              <div
                v-if="tag"
                class="form-group m-t-sm">
                <label class="typo__label multiselect-label">Tags</label>
                <multiselect
                  id="ajaxTags"
                  v-model="coupon.tags"
                  :options="tagList"
                  :multiple="true"
                  :loading="tags_loading"
                  :close-on-select="false"
                  :limit="20"
                  :max-height="170"
                  :hide-selected="true"
                  label="name"
                  track-by="id"
                  placeholder="Type to search"
                  @search-change="loadTags"/>
              </div>
              <!-- Outlets select -->
              <div class="form-group m-t-sm">
                <label class="typo__label multiselect-label">Outlets</label>
                <multiselect
                  id="ajaxOutlets"
                  v-model="coupon.outlets"
                  :options="outletList"
                  :multiple="true"
                  :loading="outlets_loading"
                  :close-on-select="false"
                  :limit="20"
                  :max-height="170"
                  :hide-selected="true"
                  label="name"
                  track-by="id"
                  placeholder="Type to search"
                  @search-change="loadOutlets"/>
                <small>Leave empty will make coupon redeemable at all outlets</small>
              </div>

              <!-- Fine print -->
              <div class="md-form-group fineprint">
                <div class="m-b-1">
                  <label class="m-b-0 p-t-sm">Term & Condition</label>&nbsp;

                  <a
                    v-if="!fineprint_template_loaded"
                    class="pull-right btn btn-sm btn-default"
                    @click="loadFinePrintTemplate()">Load Template</a>
                  <span
                    v-if="fineprint_template_loaded"
                    class="pull-right p-t-sm"
                    @click="resetFinePrintTemplate()">Clear</span>
                </div>
                <vue-editor
                  id="fineprint"
                  v-model="coupon.fineprint"
                  :editor-toolbar="customToolbar"
                  placeholder="List your Terms & Conditions here"
                  @input="handleInput"
                />
                <p>Remaining characters: {{ remainingCharacters }}/ {{ maxLength }} </p>
                <p
                  v-if="remainingCharacters <= 0"
                  style="color: red; margin-top: -10px;">Exceeded maximum characters!</p>
              </div>

              <!-- Link -->
              <div
                v-if="qrCouponLink && couponExists()"
                class="md-form-group">
                <div class="copy-link">
                  <a
                    v-clipboard:copy="qrCouponLink"
                    v-clipboard:success="onLinkCopy"
                    v-clipboard:error="onLinkError"
                    class="btn btn-xs grey-300"
                  >
                    COPY LINK
                  </a>
                  <span
                    v-if="link_copied"
                    class="m-l-sm">Link copied!</span>
                </div>
                <input
                  :value="qrCouponLink"
                  disabled
                  type="text"
                  class="md-input">
              </div>

            </form>

          </fieldset>
        </div>
      </div>
    </div>
    <div class="p-a b-t text-right">
      <button
        :disabled="loading"
        class="btn btn-fw white"
        data-dismiss="modal">Cancel</button>

      <button
        :disabled="loading"
        class="btn btn-fw primary"
        @click="submit()">Save</button>
    </div>
  </div>
</template>

<style>
.photos {
    position: relative;
    padding: 24px 0;
}
.vue-dropzone ~ label {
    font-size: 0.85em;
    z-index: 0;
    opacity: 0.5;
    position: absolute;
    top: 0px;
    left: 0px;
}
.vue-dropzone {
    padding: 15px !important;
    margin-bottom: 1rem;
}
.vue-dropzone .dz-preview {
    margin: 0 1rem 1rem 0;
    width: 25% !important;
}
.dz-custom-image-preview {
    width: 10rem;
    display: inline-block;
}
.ql-editor ul {
    padding-left: 0;
}
.what-you-get label,
.fineprint label {
    font-size: 0.85em;
}
.what-you-get span,
.fineprint span {
    text-decoration: underline;
    text-decoration-style: dotted;
}
.what-you-get span:hover,
.fineprint span:hover {
    text-decoration: underline;
    cursor: pointer;
}
.copy-link span {
    opacity: 0.8;
}
.md-input.quantity {
    width: 25%;
}
.sold,
.remaining {
    font-size: 0.85em;
    opacity: 0.5;
}
</style>

<script>
import CouponPermissionMixin from './coupon-permission';
import numeral from 'numeral';
import lodash from 'lodash';
import Auth from '@js/plugins/auth';
export default {
    mixins: [CouponPermissionMixin],

    props: {
        coupon: {
            type: Object,
            required: true,
        },
        meta: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            maxLength: 400, // Set your desired maximum length
            api_media: Laroute.route(
                'franchise.inventory.voucher-redeem.addmedia',
            ),
            mediaId: 0,
            loading: false,
            remove_media: false,
            remove_media_ids: [],
            outletList: [],
            productList: [],
            tagList: [],
            taxList: [],
            outlets_loading: false,
            products_loading: false,
            tags_loading: false,
            taxes_loading: false,
            multiselect_query_limit: 30,
            link: '',
            link_copied: false,
            what_you_get_template_loaded: false,
            fineprint_template_loaded: false,
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [],
            ],
            what_you_get_template: null,
            product: false,
            tag: false,
            modeList: [
                {
                    id: 1,
                    name: 'Flat',
                },
                {
                    id: 2,
                    name: 'Percentage',
                },
            ],
        };
    },

    computed: {
        remainingCharacters() {
            return (
                this.maxLength -
                this.removeHTMLTags(this.coupon.fineprint).length
            );
        },
        modeSelect: {
            get() {
                console.log(this.coupon.mode);
                return this.modeList.find(s => s.id === this.coupon.mode);
            },

            set(value) {
                this.coupon.mode = value.id;
            },
        },

        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        couponLink() {
            return route('coupon.show', {
                franchise: this.meta.franchise ? this.meta.franchise.slug : '',
                coupon: this.coupon.slug,
            });
        },
        qrCouponLink() {
            let qr = route('coupon.show', {
                franchise: this.meta.franchise ? this.meta.franchise.slug : '',
                coupon: this.coupon.slug,
            });
            let stringUrl =
                window.location.origin +
                '/claim/' +
                qr.urlParams.franchise +
                '/' +
                qr.urlParams.coupon;
            return stringUrl;
        },
        shareqrCouponLink() {
            let stringUrl =
                window.location.origin +
                '/claim/' +
                Auth.franchise().slug +
                '/';
            return stringUrl;
        },
        sold() {
            return this.couponExists() ? this.meta.bought : 'N/A';
        },
        remaining() {
            return this.couponExists()
                ? this.coupon.limit_quantity - this.meta.bought
                : 'N/A';
        },
        percentSold() {
            return numeral(
                this.meta.bought / this.coupon.limit_quantity,
            ).format('0%');
        },
        minimumLimitQuantity() {
            return this.couponExists()
                ? 'min_value:' + this.meta.bought
                : 'min_value:1';
        },
    },

    watch: {
        coupon() {
            this.resetForm();
        },
    },

    mounted() {
        this.loadOutlets();
        this.loadProducts();
        this.loadTags();
        this.loadTaxes();
    },

    methods: {
        removeHTMLTags(input) {
            var regex = /(<([^>]+)>)/gi;
            return input.replace(regex, '');
        },
        handleInput(newValue) {
            var string = this.removeHTMLTags(newValue);
            // Check if the content exceeds the maximum length
            if (string.length > this.maxLength) {
                // Trim the content to the maximum length
                this.coupon.fineprint = string.substring(0, this.maxLength);
            } else {
                // Update the editor content
                this.coupon.fineprint = string;
            }
        },
        forTag() {
            if (this.coupon.for_tag) {
                this.coupon.for_product = false;
                this.tag = true;
                this.product = false;
            } else {
                this.tag = false;
                this.product = false;
            }
        },
        forProduct() {
            if (this.coupon.for_product) {
                this.coupon.for_tag = false;
                this.tag = false;
                this.product = true;
            } else {
                this.tag = false;
                this.product = false;
            }
        },
        submit() {
            this.loading = true;

            this.$validator.validateAll().then(result => {
                if (!result) {
                    this.scrollFormToTop();
                    this.stopLoading();
                    return;
                }

                let data = this.getSubmittedValue();

                this.$http[this.getSubmitMethod()](
                    this.getSubmitApi(),
                    data,
                ).then(
                    response => {
                        if (response.status == '200') {
                            this.remove_media_ids = [];
                            let data = response.data.data;
                            this.successCallback(data);
                        }
                    },
                    error => {
                        toastr.error(error.statusText);
                        this.stopLoading();
                    },
                );
            });
        },

        getSubmitApi() {
            if (this.couponExists()) {
                return Laroute.route(
                    'franchise.inventory.voucher-redeem.update',
                    {
                        id: this.coupon.id,
                    },
                );
            } else {
                return Laroute.route(
                    'franchise.inventory.voucher-redeem.store',
                );
            }
        },

        couponExists(id) {
            return this.coupon.id != 0 && this.coupon.id != undefined;
        },

        scrollFormToTop() {
            $('#coupon-popup .row-body').animate({ scrollTop: 0 }, 'slow');
        },

        stopLoading() {
            this.loading = false;
        },

        getSubmittedValue() {
            let available_from = _.isNull(this.coupon.available_from)
                ? null
                : moment(this.coupon.available_from)
                      .startOf('day')
                      .format();
            let available_to = _.isNull(this.coupon.available_to)
                ? null
                : moment(this.coupon.available_to)
                      .endOf('day')
                      .format();

            return {
                name: this.coupon.name,
                description: this.coupon.description,
                status: 1,
                limit_sale: 1,
                is_recurring: this.coupon.is_recurring,
                for_tag: this.coupon.for_tag,
                for_product: this.coupon.for_product,
                mode: this.couponExists(this.coupon.id)
                    ? this.coupon.mode
                    : this.coupon.mode
                        ? this.coupon.mode.id
                        : 0,
                limit_quantity: this.coupon.limit_quantity,
                available_from: available_from,
                available_to: available_to,
                price: this.coupon.price,
                value: this.coupon.value,
                is_fineprint: this.coupon.is_fineprint,
                fineprint: this.coupon.fineprint
                    ? this.coupon.fineprint
                    : '<p></p>',
                what_you_get: this.coupon.what_you_get
                    ? this.coupon.what_you_get
                    : '<p></p>',
                remove_media: this.remove_media,
                remove_media_ids: this.remove_media_ids,
                outlets: this.coupon.outlets
                    ? this.coupon.outlets.map(obj => obj.id)
                    : [],
                products: this.coupon.products
                    ? this.coupon.products.map(obj => obj.id)
                    : [],
                tags: this.coupon.tags
                    ? this.coupon.tags.map(obj => obj.id)
                    : [],
                taxes: this.coupon.taxes
                    ? this.coupon.taxes.map(obj => obj.id)
                    : [],
            };
        },

        onSendingFile(file, xhr, formData) {
            formData.append('id', this.mediaId);
        },

        successCallback(data) {
            this.loading = false;
            if (!this.couponExists()) {
                this.$parent.initCoupon();
            } else {
                this.$parent.hide_modal();
            }

            this.alertSuccess(data);
            this.$parent.refresh();
        },

        clearErrorValidation() {
            var that = this;
            setTimeout(() => {
                that.errors.clear();
            }, 50);
        },

        alertSuccess(data) {
            let copylink = this.shareqrCouponLink + data.slug;
            let msg =
                'Coupon successfully ' +
                (!this.couponExists() ? 'created' : 'updated');
            swal({
                title: msg,
                text: 'Are you sure you want to copy this link to clipboard?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, copy it!',
            })
                .then(res => {
                    if (res.value) {
                        navigator.clipboard.writeText(copylink);
                        swal('Copied!', 'The link has been copied.', 'success');
                    }
                })
                .catch(err => {
                    swal('Something wrong', 'error');
                });
        },

        removeImage(id) {
            this.coupon.media_urls = lodash.filter(
                this.coupon.media_urls,
                media => {
                    return media.id != id;
                },
            );
            this.remove_media_ids.push(id);
            this.remove_media = true;
        },

        resetForm() {
            this.clearErrorValidation();
        },

        resetTemplate() {
            this.what_you_get_template = null;
            this.what_you_get_template_loaded = false;
            this.fineprint_template_loaded = false;
        },

        getOultetList() {
            let api = Laroute.route('franchise.vue.outlets');
            this.$http.get(api).then(response => {
                this.outlets = response.data.data;
            });
        },

        hasFileToUpload(id) {
            let files = this.$refs.dropzone.getAcceptedFiles();
            return (
                !_.isEmpty(files) && !_.isUndefined(id) && files[0].name != ''
            );
        },

        hasRejectedFile() {
            return this.$refs.dropzone.getRejectedFiles().length > 0;
        },

        uploadFile(couponId) {
            this.mediaId = couponId;
            this.$refs.dropzone.processQueue();
        },

        getSubmitMethod() {
            return this.couponExists() ? 'patch' : 'post';
        },

        onLinkCopy(e) {
            this.link_copied = true;
        },

        onLinkError(e) {},

        loadFinePrintTemplate() {
            let available_from = _.isNull(this.coupon.available_from)
                ? moment()
                      .startOf('day')
                      .format('DD MMM YYYY')
                : moment(this.coupon.available_from)
                      .startOf('day')
                      .format('DD MMM YYYY');
            let available_to = _.isNull(this.coupon.available_to)
                ? moment()
                      .startOf('day')
                      .format('DD MMM YYYY')
                : moment(this.coupon.available_to)
                      .endOf('day')
                      .format('DD MMM YYYY');
            this.coupon.fineprint =
                '<p>This voucher is valid from ' +
                available_from +
                ' to ' +
                available_to +
                '. It can be redeemed only during this period. Only one voucher can be used per transaction and cannot be exchanged for cash or other goods or services and combined with other offers. For inquiries or assistance regarding this voucher, please contact us. The voucher will expired on ' +
                available_to +
                '.</p>';
            this.fineprint_template_loaded = true;
            this.coupon.is_fineprint = 1;
        },

        resetFinePrintTemplate() {
            this.fineprint_template_loaded = false;
            this.coupon.fineprint = '';
            this.coupon.is_fineprint = 0;
        },

        changeWhatYouGetTemplate() {
            this.coupon.what_you_get = '<p>RM [Price] Cash Voucher</p>';
        },

        loadOutlets: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.outlets');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.outlets_loading = true;
            this.$http.get(api, options).then(response => {
                this.outletList = response.data.data;
                this.outlets_loading = false;
            });
        }, 500),

        loadProducts: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.products');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.products_loading = true;
            this.$http.get(api, options).then(response => {
                this.productList = response.data.data;
                this.products_loading = false;
            });
        }, 500),

        loadTags: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.tags');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.tags_loading = true;
            this.$http.get(api, options).then(response => {
                this.tagList = response.data.data;
                this.tags_loading = false;
            });
        }, 500),

        loadTaxes: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.gettaxselect');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.taxes_loading = true;
            this.$http.get(api, options).then(response => {
                this.taxList = response.data.data;
                this.taxes_loading = false;
            });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/couponredeem/vuetablecoupon_form.vue